import store from '../../../store';
export default function checkIfCanCreateQuestions() {
  let scopes = store.getters.userScopes;
  return scopes.includes('manage_questions_create');
}
